import axios from "axios";
import { useEffect, useState } from "react";
import Cookie from "cookie-universal";
import { baseURL } from "../../Api/Api";
import { Table } from "react-bootstrap";
import { Form, Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faTrash,faCartShopping } from "@fortawesome/free-solid-svg-icons";
import ContentHeader from "../../Components/Dashboard/ContentHeader";
import PaginatedItems from "../../Components/pagination/pagination";

export default function Orders() {
  //data
  const [orders, setOrders] = useState([]);
  //filter && search
  const [select, setSelect] = useState('All');
  const [search,setSearch]=useState('');
  //cookie
  const cookie = Cookie();
   //pagination
    const limit=5;
    const[page,setPage]=useState(1);
    // handle pagination
  const start = (page - 1) * limit;
  const end = start + limit;
  //get data
  useEffect(() => {
    axios.get(`${baseURL}/cart`, {
      headers: {
        Authorization: "Bearer " + cookie.get("e-commerce"),
      },
    })
    .then((response) => {
      setOrders(response.data);
    })
    .catch((err) => {
      console.log(err);
    });
  }, []);
  //filter
  const dataFilter=orders?.filter((item)=>select==='All'?item:item.status===select);
  const filteredData = dataFilter.filter((e) => e.mobile.includes(search));
  const paginatedData = filteredData.slice(start, end);
  //search && show data
  const dataShow = paginatedData?.map((item, key) => {
    const date = item.created_at.split('T')[0];
    const time = item.created_at.split('T')[1].slice(0,8);
    const totalCount = item.products.reduce(
      (acc, pro) => acc + (pro.count || 0),
      0
    );
    const totalPrice = item.products.reduce((acc, pro) => {
      const price = pro.product
        ? Number(pro.product.discount!=="0" ? pro.product.discount : pro.product.price)
        : 0;
      return acc + price * (pro.count || 0);
    }, 0);

    return (
      <tr key={key}>
        <td>{start + key + 1}</td>
        <td>{item.user?.mobile || item.mobile || "No phone"}</td>
        <td>{totalCount}</td>
        <td>${totalPrice.toFixed(2)}</td>
        <td style={{color:item.status=='Success'?'#0edd7d':item.status=='accepted'?'var(--primaryColor)':item.status=='rejected'?'red':'black'}}>{item.status}</td>
        <td>{date}</td>
        <td>{time}</td>
        <td>
          <div className="d-flex align-items-center gap-2 ">
            <FontAwesomeIcon onClick={()=>handleDelete(item.id)} cursor={'pointer'} fontSize={'20px'} color={'red'} icon={faTrash} />
            <Link to={`${item.id}`}><FontAwesomeIcon fontSize={'20px'}  icon={faPenToSquare} /></Link>
          
          </div>
      
        </td>
      </tr>
    );
  });

  //delete
  async function handleDelete(id){
     try {
        await axios.delete(`${baseURL}/cart/${id}`, {
          headers: {
            Authorization: "Bearer " + cookie.get("e-commerce"),
          },
  });
  setOrders((prov)=>prov.filter((item)=>item.id!==id));
}  
       catch (err) {
        console.log(err);
      }
    }
   //object content header
      const HeaderInfo={
          title:'Orders',
          icon:faCartShopping,
          BtnName:'Add',
          show:false,
          BtnClick:()=>{ window.location.pathname = 'dashboard/category/add'; }
      }
  return (
    <div className=" w-100">
       <ContentHeader HeaderInfo={HeaderInfo} />
       <div className="ps-2">
           <form className="d-flex gap-3">
             <select value={select} onChange={(e)=>setSelect(e.target.value)}
              style={{border: '0 solid transparent',backgroundColor: '#f7f8fa',outline:'none',}}>
              <option >All</option>
              <option >pending...</option>
              <option >rejected</option>
              <option >accepted</option>
              <option >Success</option>
             </select>
             <div className="input-group">
              <input className="form-control table-search form-control-lg"
                value={search} onChange={(e)=>setSearch(e.target.value)} type="search" placeholder="Search by contact number..." aria-label="Search" />
             </div>
           </form>
       </div>
       <div className="div-parent-table w-100">
       <Table className="users-table" striped bordered hover>
        <thead>
          <tr>
            <th>Id</th>
            <th>Number</th>
            <th>Total count</th>
            <th>Total price</th>
            <th >Status</th>
            <th >Date</th>
            <th >Time</th>
            <th style={{ width: "70px" }}>Action</th>
          </tr>
        </thead>
        <tbody>
          {dataShow.length === 0 ? (
            <tr>
              <td colSpan={10} style={{ textAlign: "center", fontSize: "20px", fontWeight: "bold", color: "#3eb57ec2" }}>
                Loading...
              </td>
            </tr>
          ) : (
            dataShow
          )}
        </tbody>
      </Table>
    </div>
    <PaginatedItems data={filteredData} setPage={setPage} itemsPerPage={limit}/>
    </div>
  );
}